import { render, staticRenderFns } from "./receivingAccountDetail.vue?vue&type=template&id=bd338e6c&scoped=true&"
import script from "./receivingAccountDetail.vue?vue&type=script&lang=js&"
export * from "./receivingAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./receivingAccountDetail.vue?vue&type=style&index=0&id=bd338e6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd338e6c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/ecommerce_h5_dev_front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bd338e6c', component.options)
    } else {
      api.reload('bd338e6c', component.options)
    }
    module.hot.accept("./receivingAccountDetail.vue?vue&type=template&id=bd338e6c&scoped=true&", function () {
      api.rerender('bd338e6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/main/receivingAccountDetail.vue"
export default component.exports